const indexBy = keyMapper => subject => subject.reduce((acc, v) => {
  acc[keyMapper(v)] = v;
  return acc;
}, {});

export default indexBy;